import React,{ useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { View, Image, TextInput, FlatList, TouchableOpacity } from 'react-native';
import Text from './CustomTextComponent';
import { THEME_COLORS, images, commonStyles } from '../themes';
import { debounce } from 'lodash'; // Import debounce from lodash

interface ILimitListingComponentProps{
    onSelect:(obj:any)=>void;
    limitBy:number;
    searchBy:string;
    options:any;
    label:string;
    values:any;
    labelField:string;
    valueField:string;
    placeholderText?:string;
    key?:string;
    multi?:boolean;
}

export const LimitListingComponent2 = props => {
    const { options } = props;
    const renderItem = (data) => {
        const {item,index} = data;
        
        return (
            <Text>{item.brand_name}</Text>
        )
    }
    return <FlatList
            renderItem={renderItem}
            maxToRenderPerBatch={10}
            data={options}
        />
}

export const LimitListingComponent=(props:ILimitListingComponentProps)=>{

    const flatListRef = useRef(null);

    const { onSelect, limitBy, searchBy, options, label, values, placeholderText, valueField, key, labelField, multi } = props;

    const [searchText,setSearchText] = useState("");
    const [collapsed,setCollapsed] = useState(true);

    const addRemoveItem=(item)=>{
        let valuesContainItem = !!values.filter(i => i[valueField] === item[valueField]).length;
        if(valuesContainItem){
            return values.filter(i => i[valueField] !== item[valueField]);
        }else{
            return [...values,item];
        }
    }

    const onItemSelect=(item)=>{
        let newValues = multi ? addRemoveItem(item) : [item];
        onSelect(newValues);
    };

    const closeCollapsible=()=>{
        moveFlatListToTop();
        setCollapsed(!collapsed);
    }

    const moveFlatListToTop=()=>{
        if(!!flatListRef && flatListRef.current){
            flatListRef.current.scrollToIndex({
                index:0,
                animated:false
            });
        }
    }

    const _renderItem=(data)=>{
        const {item,index} = data;
        const selected = !!values.length ? values.map(item => item[valueField]).includes(item[valueField]) : false;
        return (
            <View style={{flexDirection:"row",paddingVertical:5,alignItems:"center"}}>
                <TouchableOpacity onPress={()=>onItemSelect(item)}>
                    <Image source={selected ?  images.squareCheckedIcon : images.squareCheckIcon} style={{width:15,height:15}}/>
                </TouchableOpacity>
                <Text style={{marginLeft:5}}>{item[labelField]}</Text>
            </View>
        )
    }

    const debouncedSearch = useMemo(() => debounce((text) => {
        setSearchText(text);
    }, 500), []);

    useEffect(() => {
        return () => {
            debouncedSearch.cancel(); 
        };
    }, [debouncedSearch]);

    return (
        <View style={{maxHeight: collapsed ? 430 : 500,paddingVertical:10}}>
            <Text type_of_six={"three_six"} fontSize={"medium"}>{!!label ? label : ""}</Text>

            <View style={[commonStyles.input3,{flexDirection:"row",alignItems:"center",marginVertical:10,maxWidth:"90%"}]}>
                <Image source={images.searchIcon} style={{width:15,height:15,marginRight:5}}/>
                <TextInput style={[{paddingLeft: 10, outline: 'none'}]}
                        placeholder={!!placeholderText ? placeholderText : ""}
                        autoFocus={true}
                        onChangeText={debouncedSearch} 
                />
            </View>

                <FlatList 
                    data={!!options ? options.filter(item => item[searchBy].toLowerCase().includes(searchText.toLowerCase())) : []}
                    scrollEnabled={!collapsed || !!searchText}
                    ref={flatListRef}
                    keyExtractor={(item,index)=> !!key && !!item[key] ? item[key].toString() : index.toString()}
                    maxToRenderPerBatch={!!limitBy ? limitBy : 10}
                    renderItem={_renderItem}

                />

                {!!limitBy && !searchText && collapsed ? <TouchableOpacity onPress={()=>setCollapsed(!collapsed)} style={{marginTop:10}}>
                    <Text style={{color:THEME_COLORS.primaryPurple}} type_of_six={"three_six"} fontSize={"medium"}> + {options.length - limitBy} More</Text>
                </TouchableOpacity> : (!searchText ? <TouchableOpacity onPress={()=> {
                    closeCollapsible()
                }} style={{marginTop:10}}>
                    <Text style={{color:THEME_COLORS.primaryPurple}} type_of_six={"three_six"} fontSize={"medium"}>Show Less</Text>
                </TouchableOpacity> : null)}
        </View>
    )
}
